import {CLIENT_ACCOUNT_TYPES} from '@advisor/util/constants';
import ClientOnboarding from '@advisor/models/store/client/clientOnboarding';
import AccountSummary from '@advisor/models/store/accountDetails/AccountSummary';
import AumDetails from '@advisor/models/store/client/aumDetails';

export const Client = class {
  // eslint-disable-next-line max-lines-per-function
  constructor() {
    this.clients = [];
    this.topClients = [];
    this.allHouseholds = [];
    this.totalClientCount = 0;
    this.clientDetails = {
      firstName: null,
      lastName: null,
      id: null,
      riaId: null,
      riaUserId: null,
      emailVerified: null,
      lastFour: null,
      accountStatus: null,
      active: null,
      email1: null,
      phone1: null,
      dashboardAccess: null,
      settingsEmailStatus: null,
      settingsUpdateEmail: null,
      // Assigning temporary; as backend not available.
      clientSegment: 1186,
      avatar: {
        userAvatar: null,
        userUploadedAvatar: null,
      },
      goals: [],
      clientAccounts: [],
      clientAssets: [],
      legalAddress: {
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        city: null,
        zip: null,
      },
      contactInfo: {
        email1: null,
        email2: null,
        phone1: null,
        phone2: null,
      },
      mailingAddress: {
        addressLine1: null,
        addressLine2: null,
        addressLine3: null,
        city: null,
        zip: null,
      },
      riaUserName: null,
      backupRiaUserName: null,
      riaUserIdBackup: null,
      clientAumDetail: new AumDetails(),
      performanceDataLoaded: false,
      performanceReportData: [],
      performanceSummaryData: null,
      tickers: [],
      accountDetail: {
        summary: new AccountSummary(),
      },
      segment: {
        id: null,
        label: '',
      },
    };
    this.clientDocuments = [];
    this.clientTransactions = [];
    this.searchBarClients = [];
    this.searchBarTotalCount = '';
    this.accountTypes = [];
    this.clientOnBoarding = new ClientOnboarding();
    this.clientsSummary = [];
    this.accountTypes = [];
    this.goalsList = [];
    this.goalDetail = [];
    this.riskToleranceQuestionnaire = [];
    this.clientHouseholdGoals = {
      allGoals: [],
    };
  }
};

// eslint-disable-next-line consistent-return
export const checkAccountType = (account) => {
  if (!account.accountRequestStatus) {
    return false;
  }

  if (account.accountRequestStatus === CLIENT_ACCOUNT_TYPES.LINKED) {
    return account;
  }
};

export const formatClientAccount = (account) => {
  if (account.accountId && account.accountNumber) {
    return {
      id: account.accountId,
      name: `${account.accountTypeName} (${account.accountNumber})`,
      custodianId: account.custodianId,
    };
  }

  return {id: null, name: null, custodianId: null};
};
